import type { RootState } from '@/store';
import { createSelector } from '@reduxjs/toolkit';

export const auth = (state: RootState) => state.auth;

export const selectAuthToken = createSelector([auth], ({ token }) => token as unknown as string);
export const selectIsAuthSet = createSelector([auth], ({ isAuthSet }) => isAuthSet);
